<dx-select-box #selectBox
    [dataSource]="platforms"
    displayExpr="displayName"
    valueExpr="id"
    [disabled]="isDisabled"
    acceptCustomValue="false"
    searchEnabled="true"
    [showClearButton]="!isRequired"
    (selectedItemChange)="onSelectedItemChange($event)">
    <dx-validator>
        <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgRemotePlatformRequired' | translate"></dxi-validation-rule>
    </dx-validator>
</dx-select-box>
